<template>
  <section v-if="showBanner" class="bartop-trial" :style="bannerStyle">
    <div class="bartop-trial__content">
      <svg
        class="bartop-trial__icon"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span class="bartop-trial__text" v-if="daysRemaining !== null">
        Tu prueba del plan {{ planName }} termina en
        <strong
          >{{ daysRemaining }}
          {{ daysRemaining === 1 ? "día" : "días" }}</strong
        >
      </span>
      <span class="bartop-trial__text" v-else>
        {{ bannerText }}
      </span>
      <router-link to="/plans" class="bartop-trial__cta" :style="ctaStyle">
        Ver planes
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </router-link>
    </div>
  </section>
</template>

<script>
import payService from "../services/payService";

export default {
  name: "BartopPlan",
  data() {
    return {
      config: null,
      loading: false
    };
  },
  computed: {
    isPlanSubscriptions() {
      return this.$store.getters.isPlanSubscriptions;
    },
    showBanner() {
      if (!this.config || !this.config.is_active) return false;
      // Show if trial is active (days remaining > 0)
      if (this.config.trial_active && this.daysRemaining > 0) return true;
      // Show if no subscription at all
      if (!this.isPlanSubscriptions) return true;
      return false;
    },
    daysRemaining() {
      return this.config ? this.config.trial_days_remaining : null;
    },
    planName() {
      return this.config ? this.config.plan_name : "";
    },
    bannerText() {
      return this.config ? this.config.banner_text : "";
    },
    bgColor() {
      return this.config ? this.config.banner_color : "#1e1c42";
    },
    textColor() {
      return this.config ? this.config.banner_text_color : "#ffffff";
    },
    ctaColor() {
      return this.config ? this.config.banner_cta_color : "#3ecfb4";
    },
    bannerStyle() {
      return {
        background: `linear-gradient(135deg, ${this.bgColor} 0%, ${this.lighten(
          this.bgColor,
          15
        )} 100%)`,
        color: this.textColor
      };
    },
    ctaStyle() {
      return {
        background: this.ctaColor,
        color: this.bgColor
      };
    }
  },
  async created() {
    await this.fetchConfig();
  },
  methods: {
    async fetchConfig() {
      try {
        const { data } = await payService.getTrialConfig();
        if (data.success && data.data) {
          this.config = data.data;
        }
      } catch (e) {
        // silently fail
      }
    },
    lighten(hex, percent) {
      if (!hex) return "#333";
      const num = parseInt(hex.replace("#", ""), 16);
      const amt = Math.round(2.55 * percent);
      const R = Math.min(255, (num >> 16) + amt);
      const G = Math.min(255, ((num >> 8) & 0x00ff) + amt);
      const B = Math.min(255, (num & 0x0000ff) + amt);
      return `#${((1 << 24) | (R << 16) | (G << 8) | B).toString(16).slice(1)}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.bartop-trial {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 20px;
  font-family: "Plus Jakarta Sans", sans-serif;

  &__content {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__icon {
    opacity: 0.7;
    flex-shrink: 0;
  }

  &__text {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0.2px;

    strong {
      font-weight: 700;
    }
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: none;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: "Plus Jakarta Sans", sans-serif;
    white-space: nowrap;
    text-decoration: none;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
      text-decoration: none;
      color: inherit;
    }

    &:active {
      transform: translateY(0);
    }
  }
}

@media (max-width: 768px) {
  .bartop-trial {
    padding: 8px 16px;

    &__content {
      gap: 8px;
      flex-wrap: wrap;
      justify-content: center;
    }

    &__icon {
      display: none;
    }

    &__text {
      font-size: 11.5px;
      text-align: center;
    }

    &__cta {
      font-size: 11px;
      padding: 3px 12px;
    }
  }
}
</style>
